import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";

import {
  WithStyles,
  createStyles,
  Typography,
  Button,
  Modal,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Paper,
  Link,
  TableHead,
  Table,
  TableBody,
  TextField,
  Checkbox,
  ListItemText,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import contentSubtypeActions from "../../mylibrary/actions/contentSubtypeActions";
import { ContentSubType } from "../../test-template/types/ContentSubTypeBody";
import { getContentSubType } from "../../test-template/actions/testTemplateActions";
import { bindActionCreators } from "redux";
import {
  MyPATCollapse,
  MyPATLink,
  dateService,
  MyPATDialog,
  MyPATTextField,
  MyPATSelect,
} from "../../common";
import { BorderAll } from "@material-ui/icons";
import PerfectScrollbar from "react-perfect-scrollbar";
import { RequestDetailStyle } from "../styles/RequestDetailStyle";

import contentService from "../services/contentRequestServices";
import CourseData from "../../mylibrary/types/CourseData";
import classNames from "classnames";
import { fetchOwners } from "../actions/contentRequestActions";
import { contentRequestActions } from "../reducers/contentRequestReducer.js";
import CustomInfoIcon from "../../common/CustomInfoIcon";
import MyPATMultiSearch from "../../common/MyPATMultiSearch";
import RequestSubjectCard from "./RequestSubjectCard";
import {
  ContentRequest,
  RequestPriority,
  Owners,
  Client,
  Subject,
} from "../types/ContentRequest";
import subjectsServices from "../../mylibrary/services/subjectsServices";
import { RequestContentType } from "../types/ContentRequestCreate";
import { hasWorkStartedForASubject } from "../helpers/createContentRequest";
interface AddRequestOwnerProps extends WithStyles<typeof RequestDetailStyle> {
  classes: any;
  handleDialog: Function;
  subjects: any[];
  selectedSubjects: string[];
  fetchOwners: Function;
  owners: Client[];
  transferToParent: Function;
  isOwnerPresent: boolean;
  subjectOwnerMapping: any;
  alreadyModifiedOwners: any[];
  requestContentType: RequestContentType;
  compiler: any;
  isRequestForMyOrg:boolean;
  requestInfoSubjects: Subject[]
}

interface AddRequestOwnerStates {
  renderSubjects: any[];
  selectedOptions: any[];
  currentValue: string;
  tempListOwners: any[];
  uniqueOwners: any;
  subjectOwner: any;
  compiler: any;
}

class AddRequestOwner extends Component<
  AddRequestOwnerProps,
  AddRequestOwnerStates
> {
  constructor(props: AddRequestOwnerProps) {
    super(props);
    this.state = {
      renderSubjects: [],
      selectedOptions: [],
      currentValue: "",
      tempListOwners: [],
      uniqueOwners: {},
      subjectOwner: this.props.subjectOwnerMapping,
      compiler: this.props.compiler,
    };
    // this.handleSubjectChange=this.handleSubjectChange.bind(this);
    this.setSubjectData = this.setSubjectData.bind(this);
    this.handleMultiSelect = this.handleMultiSelect.bind(this);
    this.modifyOwnerList = this.modifyOwnerList.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSave = this.onSave.bind(this);
    this.checkOwnerContainSubject = this.checkOwnerContainSubject.bind(this);
    this.checkAnyOwnerExist = this.checkAnyOwnerExist.bind(this);
  }
  componentDidMount() {
    this.setSubjectData();
    if (!this.props.isOwnerPresent) {
      this.modifyOwnerList([... this.props.owners]);
    } else {
      this.checkOwnerContainSubject();
    }
  }
  getSubjectData(id: string) {
    const subjects = this.props.subjects;
    subjects.forEach((subject) => {
      if (subject._id === id) return subject;
    });
  }
  setSubjectData() {
    const { subjects, selectedSubjects } = this.props;
    let tempSubjects: any[] = [];
    subjects.forEach((subject) => {
      if (selectedSubjects.includes(subject._id)) {
        tempSubjects.push(subject);
      }
    });
    this.setState({ renderSubjects: tempSubjects });
  }
  handleMultiSelect(selectedValue: any) {
    this.setState({ currentValue: selectedValue });
  }
  modifyOwnerList(owners: any) {
    const tempListOwners: any[] = [];
    const uniqueOwners = {};
    owners.forEach((client: Client) => {
      const owner = {
        status: "draft",
        client: client,
        subjects: [],
        type: "subject",
      };
      let cname=client.name;
      if(!client.name.includes(client.users[0].name)){
        cname=`${client.name}|${client.users[0].name}`;
      }
      let tempOwner = {
        name: cname,
        id: client.id,
        users: [...client.users],
      };
      tempListOwners.push(tempOwner);
      // @ts-ignore
      uniqueOwners[`${client.id}`] = owner;
    });
    this.setState({ tempListOwners, uniqueOwners });
  }
  emptyAllSubjectFromOwners=(uniqueOwners:any)=>{
    const uniqueOwnersId=Object.keys(uniqueOwners);
    uniqueOwnersId.forEach((ownerId:any,index:number)=>{
      const owner=uniqueOwners[ownerId];
       if(owner.subjects) 
         owner.subjects=[];
    });
   return uniqueOwners; 
  }
  onSave = () => {
    const { uniqueOwners, subjectOwner } = {...this.state};
    const tempUniqueOwners: any =this.emptyAllSubjectFromOwners({... uniqueOwners});
    this.state.renderSubjects.forEach((subject) => {
      if (subjectOwner[subject._id]) {
        const owner=tempUniqueOwners[subjectOwner[subject._id].id];
        const subjects=_.get(owner,"subjects",[]);
        subjects.push({
          id: subject._id,
          name: subject.name, 
        });
        owner["subjects"]=subjects;
        owner.type="subject"
      }
    });

    let parentOwners: any = [];
    const allOwnersId = Object.keys(tempUniqueOwners);
    allOwnersId.forEach((key, index) => {
      if(tempUniqueOwners[`${key}`].subjects && tempUniqueOwners[`${key}`].subjects.length>0){
        parentOwners.push({ ...tempUniqueOwners[`${key}`] });
      }
    });
    if (this.state.compiler && !_.isEmpty(this.state.compiler)) {
      tempUniqueOwners[this.state.compiler.id].type = "test-compiler";
      delete tempUniqueOwners[this.state.compiler.id]["subjects"];
      parentOwners.push(tempUniqueOwners[this.state.compiler.id]);
    }
  
    this.props.transferToParent(
      parentOwners,
      subjectOwner,
      this.state.compiler
    );
  };
  onChange = (subjectId: string, owner: string) => {
    const { subjectOwner } = {... this.state};
    const tempsubjectOwner: any = {...subjectOwner};
    tempsubjectOwner[subjectId] = owner;
    this.setState({ subjectOwner: tempsubjectOwner });
  };
  checkOwnerContainSubject = () => {
    const listOwners = [... this.props.alreadyModifiedOwners];
    const tempListOwners: any[] = [];
    const subjectOwner: any = {};
    const uniqueOwners: any = {};
    const allOwnersList=[... this.props.owners];

    let compiler: any = {};
    
    listOwners.forEach((client) => {
      let { id='', name="", users={} } = {... client.client};
      if(!name.includes(users[0].name))
         name=`${name}|${users[0].name}`;
         let tempOwner = { name: name, id: id, users: [...users] };
         const owner = {
           status: client.status,
           client: tempOwner,
           subjects: client.subjects,
           type: client.type,
         };   
      if (client.type == "test-compiler") {
        compiler = client.client;
      } else {
        client.subjects.forEach((subject: any) => {
          subjectOwner[`${subject.id}`] = tempOwner;
        });
      }
      uniqueOwners[`${id}`] = owner;
      tempListOwners.push(tempOwner);
    });
    
    allOwnersList.forEach((client: Client) => {
      if(!uniqueOwners.hasOwnProperty(client.id)){
      const owner = {
        status: "draft",
        client: client,
        subjects: [],
        type: "subject",
      };
      let cname=client.name;
      if(!client.name.includes(client.users[0].name)){
        cname=`${client.name}|${client.users[0].name}`;
      }
      let tempOwner = {
        name: cname,
        id: client.id,
        users: [...client.users],
      };
      tempListOwners.push(tempOwner);
      // @ts-ignore
      uniqueOwners[`${client.id}`] = owner;
      }
    })
    this.setState({ uniqueOwners, tempListOwners, subjectOwner, compiler });
  };
  handleCompilers = (ownerId: string) => {
    this.setState({ compiler: ownerId });
  };
  emtpyState=()=>{
    this.setState({},()=>{this.props.handleDialog()})
  }
  checkAnyOwnerExist(){
    if(this.props.isRequestForMyOrg){
      return true;
    }
    if(!_.isEmpty(this.state.compiler)){
     return false;    
    }
    const exits=_.find(this.state.subjectOwner,(subject)=> _.isEmpty(Object.values(subject))==false);
     if(exits)
       return false;
    return true;
  }
  checkIfSubjectDisabled = (subject: any) => {
    const { requestInfoSubjects } = this.props;
    const subjectId = subject._id;
    const foundSubject = requestInfoSubjects.find(({ id }) => id === subjectId);
    if(foundSubject) {
      return hasWorkStartedForASubject(foundSubject.questions);
    }
    return false;
  }
  render() {
    const {
      classes,
      handleDialog,
      subjects,
      selectedSubjects,
      isOwnerPresent,
      requestContentType,
      isRequestForMyOrg,
      requestInfoSubjects
    } = this.props;
    const { renderSubjects, tempListOwners } = this.state;
    return (
      <MyPATDialog
        dialogOpen={isRequestForMyOrg?false:true}
        dialogHasActions={true}
        isPerfectScrollbar={false}
        dialogHeading={
          <>
            <span className={classes.requestDialogTitle}>
              Add Request Owners
            </span>
          </>
        }
        isAlignCenter={true}
        customButtonVariant="withoutBorderCloseIcon"
        onDialogClose={this.emtpyState.bind(this)}
        isCustomBackground={false}
        isborderDialogAction={false}
        otherDialogProps={{
          fullWidth: true,
          maxWidth: 'md',
          scroll: 'body'
        }}
        isOverflowVisible={true}
        hasDialogAction={false}
        isCustomWrapper = {true}
        customHtmlWrapper ={
          <>
          <Grid className={classes.dialogContainer}>
              {_.map(renderSubjects, (subject: any, index: number) => {
                const isSubjectDisabled = this.checkIfSubjectDisabled(subject);
                return (   
                  <RequestSubjectCard
                    list={tempListOwners}
                    subject={subject}
                    transferToParent={this.onChange}
                    key={index}
                    selectedValue={
                      this.state.subjectOwner[subject._id]
                        ? this.state.subjectOwner[subject._id]
                        : ""
                    }
                    isDisabled={isSubjectDisabled}
                  />
                )
              })}
            {requestContentType === RequestContentType.TEST && (
              <Grid container>
                <Grid item xs={6}>
                  <Grid container alignItems="center" justify="flex-start">
                    <Grid item>
                      <img src="/assets/svg/contentRequest/test-compilers.svg" />
                    </Grid>
                    <Grid item>
                      <Grid>
                        &nbsp;&nbsp;Specify Test Compiler:&nbsp;
                        <CustomInfoIcon
                          isInfoIcon={true}
                          isCenterArrow={true}
                          isRightArrow={false}
                          knowMoreAbout={false}
                          dialogTitle="Share Content"
                          dialogPara="A centre which will be responsible for creating tests through questions created from aforementioned subject(s)"
                          imageURL="/assets/svg/infoIcon/share.svg"
                          htmlElement=""
                          toolTipDirection="top"
                          details="Click to know more"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <MyPATMultiSearch
                    options={tempListOwners}
                    labelKey="name"
                    valueKey="id"
                    onChange={this.handleCompilers.bind(this)}
                    values={this.state.compiler}
                    isSearchAble={true}
                    name="compilers"
                    placeholderText="Add Client and user"
                  />
                </Grid>
              </Grid>
            )}
            
            <Grid className="customFooter">
              <Grid
          container
          justify="flex-end"
          spacing={8}
          alignItems="center"
          className={classes.dialogActions}
        >
          <Grid item>
            <Button
              onClick={this.emtpyState}
              color="primary"
            >
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={this.onSave}
              disabled={this.checkAnyOwnerExist()}
              className={classes.okButton}
              variant="contained"
              color="primary"
            >
              Add
            </Button>
          </Grid>
        </Grid>
            </Grid>
        </Grid>     
        
    </>
          }
      />
    );
  }
}
const mapStateToProps = (state: any) => {
  return {
    selectedSubjects:
      state.contentRequestReducer.contentRequestCreateReducer.selectedSubjects,
  };
};
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      fetchOwners,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(RequestDetailStyle)(AddRequestOwner));